import * as React from 'react'

import Box from '@mui/material/Box'
import './Layout.scss'
import { ApiClient } from '../lib/ApiClient'
import { useAuthenticated } from './auth/useAuthenticated'
import { Outlet } from 'react-router-dom';
import { UcAppBar } from './UcAppBar';

const apiClient = new ApiClient()

type MinimalLayoutProps = {
    isAuthenticating: boolean
}

export const MinimalLayout = (props: MinimalLayoutProps) => {
    const userAuth = useAuthenticated(apiClient);

    return (
        <div className="layout" key="layout">
            {userAuth.isAuthenticated && (
                <UcAppBar />
            )}
            <Box>
                {!props.isAuthenticating && <Outlet />}
            </Box>
        </div>
    )
}
